let fakeBtn = document.querySelector(".btn_fake-sort");
let listFake = document.querySelector(".custom_sort_list");

document.addEventListener("click", function () {
  listFake.classList.remove("_isActive")

})

fakeBtn.addEventListener("click", (event) => {
  const flag = fakeBtn.getAttribute("data-open-list");
  fakeBtn.setAttribute("data-open-list", flag === "false" ? "true" : "false");
  listFake.classList.toggle("_isActive");
  event.stopPropagation();
});

function selectVariant(event) {
  const sortListFalse = document.querySelectorAll(".custom_sort_list li");
  const formSort = document.querySelector('#FacetSortForm');
  const sortListTrue = document.querySelectorAll(".true_option");
  const currentOption = event.target.getAttribute("data-value");

  sortListFalse.forEach(el => el.classList.remove("_isActive"))

  sortListTrue.forEach((el, index) => {
    const trueOption = el.getAttribute("value");
    if (currentOption === trueOption) {
      sortListFalse[index].classList.add("_isActive")
      el.setAttribute("selected", "selected");
      formSort.dispatchEvent(new Event('input'));
    } else {
      el.removeAttribute("selected");
    }
  });
  event.stopPropagation();
};
